import type { ReactNode } from 'react'
import './legalPages.css'

type LegalLayoutProps = {
    title: string
    subtitle: string
    children: ReactNode
    footerNote?: string
}

function LegalLayout({ title, subtitle, children, footerNote }: LegalLayoutProps) {
    return (
        <div className="legal-wrapper">
            <header className="legal-header">
                <h1>{title}</h1>
                <h2>{subtitle}</h2>
            </header>

            <main>{children}</main>

            <footer className="legal-footer">
                <p>{footerNote ?? '© 2025 Factur 24/7 - Todos los derechos reservados'}</p>
            </footer>
        </div>
    )
}

export default LegalLayout
